import { swoopAPI, recommendationApi } from '@/api'
import { emptyGuid } from '@/utils/constants'

export const formFieldsMetaData = payload => swoopAPI.post('/api/v1/metadata', payload)

export const getProductSubTypes = () => swoopAPI.get('/api/v1/producttype/subtypes/list')

export const getGrant = opportunityId => swoopAPI.get(`/api/v1/opportunity/${opportunityId}/details`)

export const getGrants = params => recommendationApi.get(`/recommendations/${emptyGuid}?useCase=grant`, { params })

export const grantFinderGrantRegistration = data => swoopAPI.post('/api/v1/opportunity/grant/register', data)
